import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { Card, CardBody, Container } from "reactstrap";

import useAxios from 'hooks/useAxios';
import { cloneDeep } from "lodash";
import ErrorBoundary from 'components/ErrorBoundary';
import useContextService from 'hooks/useContextService';
import SearchOrders from "./components/SearchOrders";
import PurchaseOrderTable from "./components/PurchaseOrderTable";
import { onExport, getUpdatedFilterLatest } from 'utils/helper';
import { orderData } from "./components/PurchaseOrderTable/data";


let filters = [];

const PurchaseOrders = () => {

  const API = useAxios();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalItem, setTotalItem] = useState(0);
  const [selectedOption, setOptionSelected] = useState({ optionSelected: '-1' });
  const [accountype, setAccountype] = useState(1)
  const [selectedOpt, setOptSelected] = useState({ optSelected: '-1' });
  const [cpId, setcpId] = useState();
  const {
    states: { purchaseOrder },
    setStates,
  } = useContextService();
  const { search, thirdPartyAdmin, coveredEntity, searchTerms } = purchaseOrder;
  const { tenantID } = thirdPartyAdmin;
  const [columnFilters, setColumnFilters] = useState(null);


  useEffect(() => {
    if (searchTerms.thirdPartyAdminID) handleSearch(searchTerms);
  }, []);
  const [collapseSider, setcollapseSider] = useState(false);

  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    } else {
      setCollIcon(faAngleUp);
    } values.coveredEntityIDS
  };




  const handleSearch = async (filter) => {
    const {
      thirdPartyAdminID,
      coveredEntityID,
      pharmacyID,
      startDate,
      invoicenumber,
      poNumber,
      wholesalerID,
      endDate,
      orderStatusID,
      chainPharmacyID,
      pharmacyIDs,
      coveredEntityIDS,
      accountype
    } = filter;

    Object.keys(filter).map((key) => {
      const index = filters.findIndex(
        (item) => item.filterName === key && key != 'poDate'
      );
      filters.splice(index, 1);
    });
    if (orderStatusID) {
      filters = getUpdatedFilterLatest(
        'poStatusID',
        parseInt(orderStatusID),
        filters
      );
    }
    if (poNumber) {
      filters = getUpdatedFilterLatest('poid', poNumber, filters);
    }
    if (invoicenumber) {
      filters = getUpdatedFilterLatest('invoiceNumber', invoicenumber.trim(), filters);
    }
    if (startDate) {
      filters = getUpdatedFilterLatest(
        'poDate',
        startDate,
        filters,
        'startDate'
      );
    }
    if (endDate) {
      filters = getUpdatedFilterLatest(
        'poDate',
        endDate,
        filters,
        'endDate'
      );
    }
    var phIds = [];
    if (pharmacyIDs === undefined && searchTerms.pharmacyids.length !== undefined && searchTerms.pharmacyids.length > 0) {
      phIds = Array.isArray(filter.pharmacyids)
        ? filter.pharmacyids.map(item => item["value"])
        : [];
    }
    else {
      phIds = pharmacyIDs;
    }
    var covids = [];
    if (coveredEntityIDS === undefined && searchTerms.ceIds.length !== undefined && searchTerms.ceIds.length > 0) {
      covids = Array.isArray(filter.ceIds)
        ? filter.ceIds.map(item => item["value"])
        : [];
    }
    else {
      covids = coveredEntityIDS;
    }
    const tableRes = document.querySelector('.table-responsive');
    tableRes.scrollLeft = 0;
    search.filters = filters;
    search.pharmacyIDs = phIds;
    search.coveredEntityIDS = covids;
    search.associateTypeID = searchTerms?.associateTypeID;


    await fetchData(search, accountype)

  };
  // console.log(handleSearch,"search");
  const fetchData = async (search, accountype) => {
    if (accountype == 1 || searchTerms.thirdPartyAdminID != "") {
      await fetchPODetails(search)
    } else if (accountype == 2 || searchTerms.chainPharmacyID) {
      await fetchNon340PODetails(search)
    }
  }

  const fetchPODetails = async (filters) => {
    setLoading(true);
    if (!tenantID) {
      setLoading(false);
      return null;
    }
    setColumnFilters(filters)
    try {
      const { data, add } = await API.post(`/${tenantID}/PurchaseOrder/GetAll/${searchTerms.thirdPartyAdminID || 0}/${searchTerms.wholesalerID || 0}`, filters);
      if (data) {
        setData(data.items);
        setTotalItem(data.totalRecords);
        setLoading(false);
      } else {
        setData([]);
        setTotalItem(0);
        setLoading(false);
      }
    } catch (error) { setLoading(false); }
  };



  const fetchNon340PODetails = async (filters) => {
    let wholesalerID = searchTerms.wholesalerID
    if (wholesalerID) {
      filters = { ...filters, wholesalerID }
    }
    setLoading(true);
    if (!searchTerms.Non340BTenantID) {
      setLoading(false);
      return null;
    }
    setColumnFilters(filters);
    try {
      const { data, add } = await API.post(`/${searchTerms.Non340BTenantID}/PurchaseOrder/GetAllNon340BData/${searchTerms.chainPharmacyID}`, filters);
      if (data) {
        setData(data.items);
        setTotalItem(data.totalRecords);
        setLoading(false);
      } else {
        setData([]);
        setTotalItem(0);
        setLoading(false);
      }
    } catch (error) { setLoading(false); }
  };
  const handleExport = async () => {
const filterObj = cloneDeep(search);
      if (columnFilters && columnFilters.length > 0) {
        filterObj.filters = [...filterObj.filters, ...columnFilters];
      }

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    // additionalCriteria.TPAId = searchTerms.thirdPartyAdminID || 0;
    // additionalCriteria.WholesalerId = searchTerms.wholesalerID || 0;
    //additionalCriteria.OrgId = orgId.organizationID;

    filterObj.ThirdPartyAdminID =  searchTerms.thirdPartyAdminID || 0; 
     filterObj.WholesalerId = searchTerms.wholesalerID || 0;
    var payload = {};
    payload.tenantID = tenantID;
    payload.gridCode = "purchaseorder";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  };


  const handleNon340BExport = async () => {
    const filterObj = cloneDeep(search);
      if (columnFilters && columnFilters.length > 0) {
        filterObj.filters = [...filterObj.filters , ...columnFilters];
      }
    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    filterObj.chainPharmacyID = [searchTerms.chainPharmacyID] || [0];
    filterObj.WholesalerId = searchTerms.wholesalerID || 0;
    //additionalCriteria.OrgId = orgId.organizationID;
    var payload = {};
    payload.tenantID = searchTerms.Non340BTenantID;
    payload.gridCode = "Non340BPurchaseOrder";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  };

  const slelectedExportcoloumms = async () => {
const filterObj = cloneDeep(search);
      if (columnFilters && columnFilters.length > 0) {
        filterObj.filters = [...filterObj.filters, ...columnFilters];
      }
    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = true;
    filterObj.ThirdPartyAdminID = searchTerms.thirdPartyAdminID || 0;
    filterObj.WholesalerId = searchTerms.wholesalerID || 0;
    //additionalCriteria.OrgId = orgId.organizationID;
    var payload = {};
    payload.tenantID = tenantID;
    payload.gridCode = "purchaseorder";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  };




  const slelectedNon340BExportcoloumms = async () => {
const filterObj = cloneDeep(search);
      if (columnFilters && columnFilters.length > 0) {
        filterObj.filters = [...filterObj.filters, ...columnFilters];
      }

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = true;
    filterObj.TPAId = searchTerms.thirdPartyAdminID || 0;
    filterObj.chainPharmacyID = [searchTerms.chainPharmacyID] || [0];
    filterObj.WholesalerId = searchTerms.wholesalerID || 0;
    //additionalCriteria.OrgId = orgId.organizationID;
    var payload = {};
    payload.tenantID = searchTerms.Non340BTenantID;
    payload.gridCode = "Non340BPurchaseOrder";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });

  }



  const refetch = () => {
    handleSearch(searchTerms);
  };

  const handlePageChange = (filter, haveColFilter) => {
    if (haveColFilter) {
      fetchData(filter);
    } else {
      fetchData(filter);
    }
    purchaseOrder.search = { ...purchaseOrder.search, ...filter };
    setStates('purchaseOrder', purchaseOrder);
  };

  const handleReset = () => {
    setColumnFilters(null);
    setData([]);
    setTotalItem(0);
    searchTerms.pharmacyids = [];
  };

  const handleSearchColumnFilters = async (columnFilters) => {
    const filterObj = cloneDeep(search);
    filterObj.filters = [...filterObj.filters, ...columnFilters];
    await fetchData(filterObj);
    setColumnFilters(columnFilters);
  };


  return (
    <div >
      <Container fluid className="width_info">
        <div className={collapseSider ? "mb-0" : "mb-3"}>
          <Card className="border-0 shadow-top">
            <CardBody hidden={collapseSider} className="">
              <ErrorBoundary>
                <SearchOrders onSearch={handleSearch} onReset={handleReset} selectedOption={selectedOption}
                  setOptionSelected={setOptionSelected}
                  selectedOpt={selectedOpt}
                  setOptSelected={setOptSelected}
                  accountype={accountype}
                  setAccountype={setAccountype}
                  refetch = {refetch}
                />
              </ErrorBoundary>
            </CardBody>
          </Card>
        </div>
        <Card className="border-0 shadow-top">
          <CardBody className="">
            <ErrorBoundary>
              <PurchaseOrderTable
                data={data}
                // handleSelectExport={handleSelectedExport}
                // loading={loading}
                filters={search}
                totalSize={totalItem}
                thirdPartyAdmin={thirdPartyAdmin}
                AllExport={(accountype == 1) ? handleExport : handleNon340BExport}
                slelectedExport={(accountype == 1) ? slelectedExportcoloumms : slelectedNon340BExportcoloumms}
                refetch={refetch}
                selectedOption={selectedOption}
                toggleSider={toggleSider}
                collapseSider={collapseSider}
                selectedOpt={selectedOpt}
                accountype={accountype}
                setAccountype={setAccountype}
                Non340BTenantID={searchTerms.Non340BTenantID}
                cpId={searchTerms.chainPharmacyID}
                onPageChange={handlePageChange}
                onSearchColumnFilters={handleSearchColumnFilters}
              />
            </ErrorBoundary>
          </CardBody>
        </Card>
      </Container>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default PurchaseOrders;
